/* Novea : panier tiroir (API AJAX Shopify), carrousel, minuteurs, bundle produit et packs de recharges. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const NV = window.NV || {};
  const money = c => new Intl.NumberFormat("de-CH", { style: "currency", currency: NV.currency || "CHF" }).format(c / 100);
  window.nvMoney = money;

  /* ---------- tiroirs ---------- */
  const bg = $(".drawer-bg");
  const closeAll = () => { $$(".drawer").forEach(d => d.classList.remove("open")); bg && bg.classList.remove("open"); document.body.style.overflow = ""; };
  const openDrawer = id => { closeAll(); const d = document.getElementById(id); if (!d) return; d.classList.add("open"); bg && bg.classList.add("open"); document.body.style.overflow = "hidden"; };
  window.nvOpenDrawer = openDrawer;
  document.addEventListener("click", e => {
    const o = e.target.closest("[data-open]"); if (o) { e.preventDefault(); if (o.dataset.open === "cart") renderCart().then(() => openDrawer("cart")); else openDrawer(o.dataset.open); }
    if (e.target.closest("[data-close]") || e.target === bg) closeAll();
  });
  document.addEventListener("keydown", e => e.key === "Escape" && closeAll());

  function toast(msg) { const t = $(".toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); setTimeout(() => t.classList.remove("show"), 2600); }
  window.nvToast = toast;

  /* ---------- panier ---------- */
  const esc = s => String(s == null ? "" : s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  async function renderCart() {
    const body = $(".cart-body"); if (!body) return;
    const cart = await fetch((NV.root || "/") + "cart.js", { headers: { Accept: "application/json" } }).then(r => r.json());
    $$(".cart-count").forEach(c => c.textContent = cart.item_count || "");
    if (!cart.items.length) {
      body.innerHTML = `<div class="cart-empty"><p>${esc(NV.t.empty)}</p></div>`;
    } else {
      body.innerHTML = cart.items.map((it, i) => {
        const props = it.properties ? Object.entries(it.properties).filter(([k, v]) => v && k[0] !== "_").map(([k, v]) => `${esc(k)} : ${esc(v)}`).join("<br>") : "";
        const variant = it.variant_title && it.variant_title !== "Default Title" ? esc(it.variant_title) : "";
        return `<div class="cart-line">
          <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : ""}" alt="">
          <div><div class="t">${esc(it.product_title)}</div>${variant ? `<div class="v">${variant}</div>` : ""}${props ? `<div class="v">${props}</div>` : ""}
            <div class="qty"><button data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="-">−</button><span>${it.quantity}</span><button data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="+">+</button></div></div>
          <div><b>${money(it.final_line_price)}</b>${it.original_line_price > it.final_line_price ? `<div class="v"><s>${money(it.original_line_price)}</s></div>` : ""}</div></div>`;
      }).join("");
      $$("[data-line]", body).forEach(b => b.onclick = async () => {
        await fetch((NV.root || "/") + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q }) });
        renderCart();
      });
    }
    const cd = $(".cart-disc");
    if (cd) cd.innerHTML = (cart.cart_level_discount_applications || []).map(d => `<div class="subtotal" style="font-weight:500"><span>${esc(d.title)}</span><span>-${money(d.total_allocated_amount)}</span></div>`).join("");
    const st = $(".st"); if (st) st.textContent = money(cart.total_price);
    const bar = $(".ship-bar");
    if (bar && NV.freeShipping > 0) {
      const reste = NV.freeShipping - cart.total_price;
      bar.innerHTML = (reste > 0 ? esc(NV.t.shipLeft).replace("[montant]", `<b>${money(reste)}</b>`) : `<b>${esc(NV.t.shipFree)}</b>`)
        + `<div class="bar"><i style="width:${Math.min(100, cart.total_price / NV.freeShipping * 100)}%"></i></div>`;
    }
    return cart;
  }
  window.nvRenderCart = renderCart;

  async function addItems(items) {
    const r = await fetch((NV.root || "/") + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); toast(e.description || NV.t.error); return false; }
    await renderCart(); openDrawer("cart"); return true;
  }
  window.nvAddItems = addItems;

  /* ---------- minuteurs (date réelle) ---------- */
  $$("[data-end]").forEach(el => {
    const fin = new Date(el.dataset.end).getTime();
    if (isNaN(fin)) return;
    const out = $("b", el) || el;
    const tick = () => {
      const d = fin - Date.now();
      if (d <= 0) { (el.closest("[data-hide-when-ended]") || el).remove(); $$("[data-offer-only]").forEach(x => x.remove()); return; }
      const j = Math.floor(d / 864e5), h = Math.floor(d / 36e5) % 24, m = Math.floor(d / 6e4) % 60, s = Math.floor(d / 1e3) % 60;
      const p = v => String(v).padStart(2, "0");
      out.textContent = (j ? j + " j " : "") + `${p(h)}:${p(m)}:${p(s)}`;
      setTimeout(tick, 1000);
    };
    tick();
  });

  /* ---------- carrousel ---------- */
  $$(".gallery").forEach(root => {
    const track = $(".track", root); if (!track) return;
    const imgs = $$("img", track), n = imgs.length, dots = $(".dots", root), thumbs = $(".thumbs", root);
    let i = 0;
    dots.innerHTML = imgs.map((_, k) => `<button type="button" aria-label="${k + 1}"></button>`).join("");
    thumbs.innerHTML = imgs.map((im, k) => `<button type="button" aria-label="${k + 1}"><img src="${im.dataset.thumb || im.currentSrc || im.src}" alt="" loading="lazy"></button>`).join("");
    const go = k => {
      i = (k + n) % n; track.style.transform = `translateX(${-i * 100}%)`;
      $$("button", dots).forEach((b, k2) => b.classList.toggle("on", k2 === i));
      $$("button", thumbs).forEach((b, k2) => b.classList.toggle("on", k2 === i));
    };
    $$("button", dots).forEach((b, k) => b.onclick = () => go(k));
    $$("button", thumbs).forEach((b, k) => b.onclick = () => go(k));
    const prev = $(".prev", root), next = $(".next", root);
    prev && (prev.onclick = () => go(i - 1)); next && (next.onclick = () => go(i + 1));
    let x0 = null;
    track.addEventListener("touchstart", e => x0 = e.touches[0].clientX, { passive: true });
    track.addEventListener("touchend", e => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
    root.addEventListener("nv:goto", e => go(e.detail));
    go(0);
  });

  /* ---------- bundle de la fiche produit ---------- */
  $$("[data-bundle]").forEach(form => {
    const main = $("[data-main-variant]", form);
    const addons = $$("[data-addon]", form);
    const exclusive = form.dataset.exclusive === "true";
    const totals = $$("[data-total]");
    const mainPrice = () => {
      const opt = main.tagName === "SELECT" ? main.selectedOptions[0] : main;
      return +opt.dataset.price;
    };
    const update = () => {
      addons.forEach(a => a.classList.toggle("on", $("input", a).checked));
      const t = mainPrice() + addons.filter(a => $("input", a).checked).reduce((s, a) => s + (+a.dataset.price), 0);
      totals.forEach(x => x.textContent = money(t));
      const mp = $("[data-main-price]", form), mc = $("[data-main-compare]", form);
      if (main.tagName === "SELECT") {
        const o = main.selectedOptions[0];
        mp && (mp.textContent = money(+o.dataset.price));
        mc && (mc.textContent = +o.dataset.compare > +o.dataset.price ? money(+o.dataset.compare) : "");
        const img = +o.dataset.media; if (img >= 0) $(".gallery") && $(".gallery").dispatchEvent(new CustomEvent("nv:goto", { detail: img }));
      }
    };
    addons.forEach(a => $("input", a).addEventListener("change", e => {
      if (exclusive && e.target.checked) addons.forEach(x => x !== a && ($("input", x).checked = false));
      update();
    }));
    main.tagName === "SELECT" && main.addEventListener("change", update);
    $$("[data-atc]").forEach(btn => btn.addEventListener("click", async e => {
      if (!addons.length) return; // sans options du thème : formulaire Shopify natif (Rapi Bundle s'en charge)
      e.preventDefault();
      const id = main.tagName === "SELECT" ? main.value : main.dataset.mainVariant;
      const items = [{ id: +id, quantity: 1 }];
      addons.forEach(a => $("input", a).checked && items.push({ id: +a.dataset.addon, quantity: +a.dataset.qty || 1 }));
      btn.disabled = true; await addItems(items); btn.disabled = false;
    }));
    update();
    const sticky = $(".sticky-atc"), ref = $("[data-atc]", form);
    if (sticky && ref && "IntersectionObserver" in window)
      new IntersectionObserver(([e]) => sticky.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0)).observe(ref);
  });

  /* ---------- packs de recharges (variantes du produit) ---------- */
  $$("[data-packs]").forEach(form => {
    const parfums = JSON.parse(form.dataset.scents || "[]");
    const label = form.dataset.flaskLabel || "Flacon";
    const opts = $$("[data-pack]", form), total = $$("[data-total]");
    const choix = {};
    const render = () => {
      opts.forEach(o => {
        const on = $("input", o).checked; o.classList.toggle("on", on);
        const box = o.nextElementSibling && o.nextElementSibling.matches(".pack-scents") ? o.nextElementSibling : null;
        if (box) box.remove();
        if (on && parfums.length) {
          const n = +o.dataset.flasks || 1, k = o.dataset.pack;
          choix[k] = choix[k] || Array(n).fill(parfums[0]);
          o.insertAdjacentHTML("afterend", `<div class="pack-scents">${choix[k].map((v, j) => `<label>${esc(label)} ${j + 1}<select data-j="${j}">${parfums.map(f => `<option ${f === v ? "selected" : ""}>${esc(f)}</option>`).join("")}</select></label>`).join("")}</div>`);
          $$("select", o.nextElementSibling).forEach(s => s.onchange = () => choix[k][+s.dataset.j] = s.value);
        }
        if (on) total.forEach(t => t.textContent = money(+o.dataset.price));
      });
    };
    opts.forEach(o => $("input", o).addEventListener("change", render));
    $$("[data-atc]", form).forEach(btn => btn.addEventListener("click", async () => {
      const o = opts.find(x => $("input", x).checked); if (!o) return;
      const properties = {};
      (choix[o.dataset.pack] || []).forEach((v, j) => properties[`${label} ${j + 1}`] = v);
      const n = +o.dataset.flasks || 1, unit = form.dataset.unit; // un pack = n flacons à l'unité (remise « 2 + 1 offerte » au panier)
      const item = unit && n > 1 ? { id: +unit, quantity: n, properties } : { id: +o.dataset.pack, quantity: 1, properties };
      btn.disabled = true; await addItems([item]); btn.disabled = false;
    }));
    render();
  });

  document.addEventListener("shopify:section:load", () => location.reload());
  renderCart().catch(() => {});
})();
